import React, { useMemo, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiCalculator, mdiCloseCircle, mdiProgressWrench } from "@mdi/js";

import calculationRest from "../../../rest/calculationRest";

import { Svg } from "../../components/Svg";
import { Output } from "../../components/Output";
import { DropdownCaret, Option } from "../../components/DropdownCaret";
import { WorstcaseDataDialog } from "./WorstcaseDataDialog";
import { ValidationProvider } from "../../contexts/ValidationContext";

const LeftCellStyle = styled.td`
    text-align: left;
    > div {
        height: 12px;
    }
`;

const MenuCellStyle = styled.td`
  >div {
      margin-top: -3px;
      margin-bottom: -10px;
  }
`;

export const WorstcaseDataItem = ({ antenna }) => {

    const [showWorstcaseDataDialog, setShowWorstcaseDataDialog] = useState(false);
    const calculating = useMemo(() => antenna.antennaCalcSettings?.some(acs => !acs.calculation?.resultAvailable), [antenna]);

    const onCloseWorstcaseDataDialog = () => setShowWorstcaseDataDialog(false);

    const onCancelCalculations = async () => {
        await calculationRest.cancelAntenna(antenna.id);
    };

    const decodeOriginType = originType => {
        if (originType === "V") {
            return "V";
        } else if (["P", "S", "T"].includes(originType)) {
            return "N";
        }
        return "F";
    };

    return (
        <>
            <tr>
                <MenuCellStyle width="5">
                    {!antenna.virtual &&
                        <DropdownCaret>
                            <Option
                                svgIcon={mdiCalculator}
                                disabled={calculating}
                                onClick={() => setShowWorstcaseDataDialog(true)}>
                                {intl.get("worstcaseData.calculate")}
                            </Option>
                            <Option svgIcon={mdiCloseCircle}
                                onClick={() => onCancelCalculations()}
                                disabled={!calculating}>
                                {intl.get("common.cancel")}
                            </Option>
                        </DropdownCaret>
                    }
                </MenuCellStyle>
                <LeftCellStyle>{antenna.manufacturer}</LeftCellStyle>
                <LeftCellStyle>{antenna.name}</LeftCellStyle>
                <LeftCellStyle>
                    <Output value={antenna.apertureHeight} type="decimal" fractionDigits="3" />
                </LeftCellStyle>
                <LeftCellStyle>{decodeOriginType(antenna.originType)}</LeftCellStyle>
                <LeftCellStyle>
                    {calculating &&
                        <div>
                            <Svg path={mdiProgressWrench} size="16" />
                        </div>
                    }
                    {!calculating && (
                        <Output
                            value={
                                antenna.antennaSettings
                                    ? (antenna.antennaSettings?.some(acs => acs.worstcaseDataFarField && acs.calculation?.resultAvailable) ? "F" : "") +
                                    (antenna.antennaSettings?.some(acs => !acs.worstcaseDataFarField && acs.calculation?.resultAvailable) ? " N" : "")
                                    : ""
                            }
                        />
                    )}
                </LeftCellStyle>
            </tr>
            {showWorstcaseDataDialog &&
                <ValidationProvider>
                    <WorstcaseDataDialog antenna={antenna} onClose={onCloseWorstcaseDataDialog} />
                </ValidationProvider>
            }
        </>
    );
};